import { AccessComponentEnum, AccessLevelEnum } from 'graphql-common';
import { APP_URLS } from 'constants/urls';
import { NavItemTypeEnum } from '@lib/components/Menu/Menu';
import Icons from '@lib/components/Icons/Icons';
import { NavItemArgs } from './types';

export default function getUsersNavItem(args: NavItemArgs) {
  const { id = '', pathname, t, getUserAccessByComponent } = args;
  const isUsersAvailable =
    getUserAccessByComponent(AccessComponentEnum.UsersManagement) !==
    AccessLevelEnum.LimitedRead;
  const isDepartmentsAvailable =
    getUserAccessByComponent(AccessComponentEnum.DepartmentsManagement) !==
    AccessLevelEnum.LimitedRead;
  return {
    id: 'manage-users',
    title: t('manage-users'),
    leftIcon: Icons.team,
    to: APP_URLS.dashboard.users.index.getPathWithQuery(),
    type: NavItemTypeEnum.Primary,
    predictorFnVisible: () => isUsersAvailable || isDepartmentsAvailable,
    predictorFnActive: () => {
      return (
        APP_URLS.dashboard.teams.index.isTheSameUrlAs(pathname) ||
        APP_URLS.dashboard.teams.add.isTheSameUrlAs(pathname) ||
        APP_URLS.dashboard.teams.edit.isTheSameUrlAs(pathname, {
          pathParts: { id },
        }) ||
        APP_URLS.dashboard.teams.view.isTheSameUrlAs(pathname, {
          pathParts: { id },
        }) ||
        APP_URLS.dashboard.teams.members.isTheSameUrlAs(pathname, {
          pathParts: { id },
        }) ||
        APP_URLS.dashboard.teams.departments.isTheSameUrlAs(pathname, {
          pathParts: { id },
        }) ||
        APP_URLS.dashboard.departments.index.isTheSameUrlAs(pathname) ||
        APP_URLS.dashboard.departments.add.isTheSameUrlAs(pathname) ||
        APP_URLS.dashboard.departments.edit.isTheSameUrlAs(pathname, {
          pathParts: { id },
        }) ||
        APP_URLS.dashboard.departments.view.isTheSameUrlAs(pathname, {
          pathParts: { id },
        }) ||
        APP_URLS.dashboard.departments.members.isTheSameUrlAs(pathname, {
          pathParts: { id },
        }) ||
        APP_URLS.dashboard.departments.accessGroups.isTheSameUrlAs(pathname, {
          pathParts: { id },
        }) ||
        APP_URLS.dashboard.departments.tasks.isTheSameUrlAs(pathname, {
          pathParts: { id },
        }) ||
        APP_URLS.dashboard.departments.interventions.isTheSameUrlAs(pathname, {
          pathParts: { id },
        })
      );
    },
    children: [
      {
        id: 'members',
        title: t('members'),
        to: APP_URLS.dashboard.users.index.getPathWithQuery(),
        type: NavItemTypeEnum.PrimarySub,
        end: true,
        predictorFnVisible: () => isUsersAvailable,
        predictorFnActive: () => {
          return (
            APP_URLS.dashboard.users.view.isTheSameUrlAs(pathname, {
              pathParts: { id },
            }) ||
            APP_URLS.dashboard.users.viewAccess.isTheSameUrlAs(pathname, {
              pathParts: { id },
            }) ||
            APP_URLS.dashboard.users.editAccess.isTheSameUrlAs(pathname, {
              pathParts: { id },
            })
          );
        },
      },
      {
        id: 'teams',
        title: t('teams'),
        to: APP_URLS.dashboard.teams.index.getPathWithQuery(),
        type: NavItemTypeEnum.PrimarySub,
        end: true,
        predictorFnVisible: () => isUsersAvailable,
        predictorFnActive: () => {
          return (
            APP_URLS.dashboard.teams.add.isTheSameUrlAs(pathname) ||
            APP_URLS.dashboard.teams.edit.isTheSameUrlAs(pathname, {
              pathParts: { id },
            }) ||
            APP_URLS.dashboard.teams.view.isTheSameUrlAs(pathname, {
              pathParts: { id },
            }) ||
            APP_URLS.dashboard.teams.members.isTheSameUrlAs(pathname, {
              pathParts: { id },
            }) ||
            APP_URLS.dashboard.teams.departments.isTheSameUrlAs(pathname, {
              pathParts: { id },
            })
          );
        },
      },
      {
        id: 'departments',
        title: t('departments'),
        to: APP_URLS.dashboard.departments.index.getPathWithQuery(),
        type: NavItemTypeEnum.PrimarySub,
        end: true,
        predictorFnVisible: () => isDepartmentsAvailable,
        predictorFnActive: () => {
          return (
            APP_URLS.dashboard.departments.add.isTheSameUrlAs(pathname) ||
            APP_URLS.dashboard.departments.edit.isTheSameUrlAs(pathname, {
              pathParts: { id },
            }) ||
            APP_URLS.dashboard.departments.view.isTheSameUrlAs(pathname, {
              pathParts: { id },
            }) ||
            APP_URLS.dashboard.departments.members.isTheSameUrlAs(pathname, {
              pathParts: { id },
            }) ||
            APP_URLS.dashboard.departments.accessGroups.isTheSameUrlAs(
              pathname,
              {
                pathParts: { id },
              },
            ) ||
            APP_URLS.dashboard.departments.tasks.isTheSameUrlAs(pathname, {
              pathParts: { id },
            }) ||
            APP_URLS.dashboard.departments.interventions.isTheSameUrlAs(
              pathname,
              {
                pathParts: { id },
              },
            )
          );
        },
      },
    ],
  };
}
